import React from "react";

const logos = [
  { src: 'https://aigurufiles.s3.amazonaws.com/images/awsLogo.png', alt: "AWS" },
  { src: 'https://aigurufiles.s3.amazonaws.com/images/microsoftLogo.png', alt: "Microsoft" },
  { src: 'https://aigurufiles.s3.amazonaws.com/images/googleLogo.png', alt: "Google" },
  { src: 'https://aigurufiles.s3.amazonaws.com/images/courseraLogo.png', alt: "Coursera" },
  { src: 'https://aigurufiles.s3.amazonaws.com/images/udemyLogo.png', alt: "Udemy" },
  { src: 'https://aigurufiles.s3.amazonaws.com/images/mavenLogo.png', alt: "Maven" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/cerebras-logo.jpg', alt: "Cerebras" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/citi-logo.png', alt: "Citi" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/corsair-logo.png', alt: "Corsair" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/DG-logo.png', alt: "DG" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/ericsson-logo.png', alt: "Ericsson" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/jmc-papers-llc.png', alt: "JMC" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/merck-logo.png', alt: "Merck" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/nwn-carousel-logo.png', alt: "NWN" },
  { src: 'https://aigurupublic.s3.us-east-1.amazonaws.com/Wells_Fargo_Logo.svg', alt: "Wells Fargo" },
];

const LogoCarousel = () => {
  return (
    <div className="relative overflow-hidden py-8">
      <div className="flex w-[200%] space-x-8 animate-marquee">
        {logos.concat(logos).map((logo, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-48 h-24 flex justify-center items-center"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="w-auto h-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;

